<template>
  <div>
    <individual v-if="$route.query.user_type === 'Individual'" />
    <Bussiness v-else-if="$route.query.user_type === 'Business'" />
    <OverlayPageVue :showOverlay="loader" />
  </div>
</template>
<script>
import individual from "./Individual.vue";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import alerts from "@/mixins/alerts";
import Bussiness from "./Bussiness.vue";
import userService from "@/services/UserService/userService.js";

export default {
  props: ["user_type"],
  mixins: [alerts],
  components: {
    individual,
    Bussiness,
    OverlayPageVue,
  },
  data() {
    return {
      selectedComponent: null,
      BusinessUserData: null,
      loader: false,
    };
  },
  computed: {},
  watch: {},
  async mounted() {
    if (this.$route.query.user_type === "Individual") {
      this.selectedComponent = this.$route.query.user_type;
    }
  },
  methods: {
    async getProfileById() {
      var profileData = {
        info: null,
        userStatus: null,
      };
      const params = {
        customer_id: !isNaN(this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid) && !isNaN(parseFloat(this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid)) ? parseInt(this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid, 10) : (this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid),
      };
      this.loader = true;
      try {
        const responseData = await userService.getRemittenceId(params);
        if (responseData.data.status_code === 200) {
          if (responseData.data.data && responseData.data.data.length > 0) {
            profileData.info = responseData.data.data[0];
            profileData.userStatus = responseData.data.data[0].userStatus;
            this.loader = false;
            this.$emit("profileInfo", responseData.data.data[0]);
          } else {
            profileData = {
              info: null,
              userStatus: null,
            };
            this.showAlertError(responseData.data.message);
          }
        }
        console.log("remiteeProfile: ", responseData);
      } catch (e) {
        console.error(e);
      }
      return profileData;
    },
  },
  async created() {},
};
</script>
<style lang="" scoped></style>
